var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { useCommentsActions, useMessageThreadsByAnchor } from '@data/hooks/comments';
import { useGroups, useUsers } from '@data/hooks/usersAndGroups';
import { useOutsideClick } from '@hooks/useOutsideClick';
import UserAvatar from '@shared/userprofile/Avatar';
import { FlexRow } from '@styled/FlexWrappers';
import { ContextAddCommentWrap, ContextCommentsWrap } from '@styled/Sidebars';
import { appColors } from '@styled/useTheme';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { getInitials } from '../../data/user/user';
import { useAuth } from '../../providers/AuthProvider';
import { Attachemnt, AttachmentInput } from './Attachments';
import CommentThread, { COMMMENT_TEXTAREA, createUserByIdMap, getMentionData } from './CommentThread';
import { MentionInput } from './Mentions';
export function ContextComments(props) {
    var _a = __read(useState(-1000), 2), left = _a[0], setLeft = _a[1];
    var _b = __read(useState(-1000), 2), bottom = _b[0], setBottom = _b[1];
    var wrapRef = useRef(null);
    useEffect(function () {
        var newLeft = props.commentsData.x;
        var newBottom = window.innerHeight - props.commentsData.y;
        if (newLeft + 360 > window.innerWidth) {
            newLeft = newLeft - 320;
        }
        setLeft(newLeft);
        setBottom(newBottom);
    }, [props.commentsData.x, props.commentsData.y]);
    useOutsideClick(wrapRef, props.close, false, true);
    var maxHeight = window.innerHeight - bottom - 100;
    return ReactDOM.createPortal(React.createElement(ContextCommentsWrap, { ref: wrapRef, style: { left: left, bottom: bottom } },
        React.createElement(Comments, { commentsData: props.commentsData, maxHeight: maxHeight })), document.getElementById('portal'));
}
function Comments(props) {
    var user = useAuth().user;
    var users = useUsers();
    var groups = useGroups();
    var mentionData = getMentionData(users, groups);
    var userMapById = createUserByIdMap(users);
    var _a = __read(useState(0), 2), currCommentThreadIdx = _a[0], setCurrCommentThreadIdx = _a[1];
    var messageThreadsByAnchor = useMessageThreadsByAnchor();
    var commentThreads = messageThreadsByAnchor.get(props.commentsData.anchor);
    if (!commentThreads) {
        return null;
    }
    var currCommentThread = commentThreads[currCommentThreadIdx];
    var arrows = null;
    if (commentThreads.length > 1) {
        arrows = {
            current: currCommentThreadIdx + 1,
            all: commentThreads.length,
            action: function (idx) {
                if (idx > commentThreads.length) {
                    setCurrCommentThreadIdx(0);
                }
                else if (idx < 1) {
                    setCurrCommentThreadIdx(commentThreads.length - 1);
                }
                else {
                    setCurrCommentThreadIdx(idx - 1);
                }
            },
        };
    }
    return (React.createElement(React.Fragment, null, currCommentThread && (React.createElement(CommentThread, { key: currCommentThread.id + currCommentThreadIdx, messageThread: currCommentThread, mentionData: mentionData, currentUser: user, arrows: arrows, maxHeight: props.maxHeight, userMapById: userMapById }))));
}
export function ContextAddComment(props) {
    var L = useLanguage().L;
    var user = useAuth().user;
    var _a = useCommentsActions(), addMessageThread = _a.addMessageThread, isAddingMessageThread = _a.isAddingMessageThread;
    var users = useUsers();
    var groups = useGroups();
    var mentionData = getMentionData(users, groups);
    var _b = __read(useState([]), 2), attachments = _b[0], setAttachments = _b[1];
    var _c = __read(useState(-1000), 2), left = _c[0], setLeft = _c[1];
    var _d = __read(useState(-1000), 2), bottom = _d[0], setBottom = _d[1];
    useEffect(function () {
        var newLeft = props.x;
        var newBottom = window.innerHeight - props.y;
        if (newLeft + 360 > window.innerWidth) {
            newLeft = newLeft - 320;
        }
        setLeft(newLeft);
        setBottom(newBottom);
    }, [props.x, props.y]);
    var wrapRef = useRef(null);
    useOutsideClick(wrapRef, props.close, false, true);
    function createCommentThreadHandler(mentionedUserIds, mentionedGroupIds, rawContent) {
        return __awaiter(this, void 0, void 0, function () {
            var content;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((!rawContent.blocks.some(function (b) { return !!b.text; }) && !attachments.length) || isAddingMessageThread) {
                            return [2 /*return*/];
                        }
                        content = JSON.stringify(rawContent);
                        return [4 /*yield*/, addMessageThread({
                                message: {
                                    anchor: props.anchor,
                                    content: content,
                                    mentionedUserIds: mentionedUserIds,
                                    mentionedUserGroupIds: mentionedGroupIds,
                                },
                                files: attachments.length ? attachments : undefined,
                            })];
                    case 1:
                        _a.sent();
                        setAttachments([]);
                        props.close();
                        return [2 /*return*/];
                }
            });
        });
    }
    return ReactDOM.createPortal(React.createElement(ContextAddCommentWrap, { ref: wrapRef, style: { left: left, bottom: bottom } },
        React.createElement(FlexRow, null,
            React.createElement(UserAvatar, { color: "white", backgroundColor: appColors.ui.dark, size: 32, initials: getInitials(user), containerStyle: { marginRight: 10 } }),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexGrow: 1 } },
                React.createElement(MentionInput, { mentionData: mentionData, style: COMMMENT_TEXTAREA, placeholder: L('Add comment or tag others with @...'), onDone: createCommentThreadHandler, autoFocus: true, disabled: isAddingMessageThread, footer: !!attachments.length && (React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginTop: 8 } }, attachments.map(function (a, idx) { return (React.createElement(Attachemnt, { key: idx, id: idx, name: a.name, onRemove: function (id) { return setAttachments(attachments.filter(function (a, i) { return i !== id; })); } })); }))) }),
                React.createElement(AttachmentInput, { disabled: isAddingMessageThread, onChange: function (e) {
                        var _a, _b, _c;
                        var files = [];
                        for (var i = 0; i < ((_b = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); i++) {
                            var file = (_c = e.target.files) === null || _c === void 0 ? void 0 : _c.item(i);
                            if (file) {
                                files.push(file);
                            }
                        }
                        setAttachments(__spreadArray(__spreadArray([], __read(attachments), false), __read(files), false));
                    } })))), document.getElementById('portal'));
}
